import React, { Component } from 'react';

class renderHeader extends Component {
    render() {
        return (
           <header className="hud-middle-center-header">
            <div className="row">
                <div className="col-12">
                    <div className="hud-title">
                        {this.props.titulo}
                    </div>
            </div>
            </div>
        </header>
        );
    }
}

export default renderHeader;


// WEBPACK FOOTER //
// ./src/container/renderHeader.js